export enum Interactivity {
  Classic = 0,
  Smart = 1,
  Interactive = 2,
}
